
import {Component} from './base';

export class ReleaseNotesComponent extends Component {
  public static shouldLoad() {
    return $('#releases-modal').length > 0;
  }

  public load() {
    $('#releases-modal').modal({
      show: true,
    });
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/release-notes.ts